/*
 * @Author: limingshuang limingshuang@yunhdkc.com
 * @Date: 2024-08-05 17:07:17
 * @LastEditors: limingshuang limingshuang@yunhdkc.com
 * @LastEditTime: 2024-08-14 16:49:39
 * @FilePath: \dyt_html_v2.0\src\pages\registration\setPiont\setPiontRegistretion.js
 * @Description: 用于埋点
 */
const $store = window.$store
async function getHosInfo(hos_code) {
    let hosInfo = {}
    await $store.getters.getHospitalById(hos_code).then(res => {
        hosInfo = res
    })
    return hosInfo
}
async function getHosAndDepAndDocInfo(doc_id) {
    let docInfo = {}
    await $store.getters.getHospAndDepAndDocById(doc_id).then(res => {
        console.log('docInfo',docInfo);
        
        docInfo = res
    })
    console.log('docInfo,retunr',docInfo);
    
    return docInfo
}

/**
 * @description: 含有医院信息的埋点方法
 * @param {*} hinaName 埋点方法名
 * @param {*} hosCode hoscode
 * @param {*} data 数据参数
 * @return {*}
 */
export async function setPiontByHosInfo(hinaName,hosCode,data) {
    const {hospital_area_code:hos_code, name:hos_area_name ,hospital_id:hos_id, hospital_name:hos_name } =  await getHosInfo(hosCode)
    const hosInfo =  {hos_code, hos_area_name ,hos_id, hos_name }
    window.track_try_catch(hinaName,{
        ...data,
        ...hosInfo
    })
}
/**
 * @description: 含有医院和科室以及医生信息的埋点方法
 * @param {*} hinaName 埋点方法名
 * @param {*} docId docId
 * @param {*} data 数据参数
 * @return {*}
 */
export async function setPiontByHosAndDepAndDocInfo(hinaName,docId,data) {
    const {
        hospital_area_code:hos_code, 
        hospital_area_name:hos_area_name,
        hospital_id:hos_id, 
        hospital_name:hos_name,
        department_id:ev_depart_id,
        department_name:ev_depart_name,
        id:ev_doctor_id,
        name:ev_doctor_name
     } =  await getHosAndDepAndDocInfo(docId)
     console.log("hos_name",hos_name);
     
    const hosInfo =  {hos_code, hos_area_name ,hos_id, hos_name,ev_depart_id,ev_depart_name,ev_doctor_id,ev_doctor_name }
    console.log('hosInfo',hosInfo);
    
    window.track_try_catch(hinaName,{
        ...data,
        ...hosInfo
    })
}
